import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogComponent, DialogData } from '../dialog/dialog.component';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})
export class ModalComponent {
  form: FormGroup;
  constructor(
    private authService: AuthService,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData
  ) {
    this.addFieldsControls();
    this.dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  yesOnClick(): void {
    this.dialogRef.close(true);
  }

  addFieldsControls() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  sendEmailToRequestPassword() {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    this.authService
      .sendEmailToRequestPassword(this.form.value)
      .then((res) => {
        this.toast.success(res.message);
        this.dialogRef.close();
      })
      .catch((err) => {
        this.toast.error(err.error.message || 'Falha');
      });
  }
}
